<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_file_type') || '文档类型'"
            prop="fileType"
          >
            <dict-select
              v-model="formData.fileType"
              size="medium"
              url="/master/common/dict/biz"
              :placeholder="$l('form_pe_file_type') || '请选择文档类型'"
              style="width: 100%"
              filterable
              clearable
              :body="fileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('from_label_is_common') || '是否通用文档'"
            prop="isCommon"
          >
            <el-col>
              <el-radio-group v-model="formData.isCommon">
                <el-radio label="Y">
                  {{ $l('form_item_currency' || '通用') }}
                </el-radio>
                <el-radio label="N">
                  {{ $l('form_item_specify_batch') || '指定批次' }}
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <TechDocList :orderCode="orderCode" ref="techDoc" />
      </el-row>
      <el-row v-if="'N' === formData.isCommon">
        <OrderBatch :orderCode="orderCode" ref="orderBatch" />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import OrderBatch from '../order-batch'
import TechDocList from '../tech-doc-list'

export default {
  mixins: [EditLoading],
  components: { OrderBatch, TechDocList },
  props: {
    orderCode: String,
  },
  data() {
    return {
      fileTypeParams: { dictType: 'fileType' },
      formData: {},
      listFile: [],
      rules: {
        fileType: [
          {
            required: true,
            message: this.$l('form_pe_file_type') || '请选择文档类型',
            trigger: 'change',
          },
        ],
        isCommon: [
          {
            required: true,
            message: this.$l('form_pe_is_common') || '请选择是否通用文档',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const techDocList = this.$refs.techDoc.getTableData()
      if (!techDocList || !techDocList.length) {
        this.$message.warning(
          this.$l('INDEX.tips_upload_file') || `请选择需要上传的文件`
        )
        return
      }
      this.listFile = techDocList.map((item) => {
        return {
          fileCode: item.fileCode,
          fileName: item.fileName,
          fileUrl: item.fileUrl,
        }
      })
      let listOrderBatchCode = []
      if (this.formData.isCommon === 'N') {
        const listOrderbatch = this.$refs.orderBatch.getTableData()
        if (!listOrderbatch || !listOrderbatch.length) {
          this.$message.warning(
            this.$l('form_pr_select_order_batch') || `请选择指定的批次`
          )
          return
        }
        listOrderBatchCode = listOrderbatch.map((item) => item.orderBatchCode)
      }

      this.loadingOpen()
      const params = {
        ...this.formData,
        orderCode: this.orderCode,
        listFile: this.listFile,
        listOrderBatchCode,
      }
      this.$api
        .orderInspectionDocBatchUploadApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('table_Upload_failed') || '上传失败')
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
